import { gql } from '@apollo/client'

import { USER_AND_TOKENS_FRAGMENT } from '../fragments'

const LOGIN_WITH_GOOGLE_ID_TOKEN_MUTATION = gql`
  mutation loginWithGoogleIdToken($googleIdToken: String!) {
    loginWithGoogleIdToken(googleIdToken: $googleIdToken) {
      ...UserAndTokensFragment
    }
  }

  ${USER_AND_TOKENS_FRAGMENT}
`

export default LOGIN_WITH_GOOGLE_ID_TOKEN_MUTATION
